import { type QueryClient } from '@tanstack/react-query';
import { type LoaderFunctionArgs, type RouteObject } from 'react-router-dom';

import { getTranslationLanguagesQuery } from '@/api/translation/getTranslationLanguages';
import { ensureAppQueryData } from '@/hooks/useAppQuery';

export const translationsRoute = (queryClient: QueryClient): RouteObject => ({
  path: 'translations',
  children: [
    {
      path: '',
      loader: async ({ params }: LoaderFunctionArgs) => {
        const { gameCode, sandboxCode } = params;
        if (!gameCode || !sandboxCode) {
          throw new Error('Game code and sandbox code are required');
        }
        return {
          locales: await ensureAppQueryData(
            queryClient,
            { gameCode, sandboxCode },
            getTranslationLanguagesQuery(),
          ),
        };
      },
      lazy: async () => await import('./translations'),
    },
  ],
});
